export default "__VITE_ASSET__33855698__"